// Ссылка «написать в WhatsApp» (накопитель V1 №22): wa.me принимает номер
// цифрами без «+» и прочих разделителей; текст — через `?text=`.
// Дубль frontend/vision/src/lib/whatsapp.ts — в @starling/core нет utils-слоя.

/** `https://wa.me/<цифры номера>[?text=…]`. */
export function whatsappUrl(phone: string, text?: string): string {
  const digits = phone.replace(/\D/g, '');
  const base = `https://wa.me/${digits}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}
